import React from 'react';
import { connect } from 'react-redux';
import * as CardActions from '../../redux/actions/card.actions.js';
import StandardDeviceEncodeForm from '../forms/StandardDeviceEncodeForm.jsx';
import StandardDeviceWaitKeyForm from '../forms/StandardDeviceWaitKeyForm.jsx';

@connect((state) => ({
  encoders: state.cards.encoders,
}))
class StandardDeviceWaitKeyView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      errorMessage: null,
      success: false,
    };
  }

  async onHandleSubmit(formValues) {
    const { dispatch } = this.props;
    const { encoderId } = formValues;
    this.setState({ isLoading: true, errorMessage: null, success: false });
    try {
      const response = await dispatch(CardActions.keyCheckForUpdate(encoderId));
      if (response.success) {
        this.setState({ isLoading: false, success: true, errorMessage: null });
        dispatch(CardActions.fetchCards());
      } else {
        this.setState({ isLoading: false, success: false, errorMessage: response.errorMessage });
      }
    } catch (error) {
      this.setState({ isLoading: false, success: false, errorMessage: error.errorMessage || 'Failed to encode card' });
    }
  }

  render() {
    const { encoders } = this.props;
    const { isLoading, success, errorMessage } = this.state;
    return (
      <StandardDeviceWaitKeyForm
        encoders={encoders}
        isLoading={isLoading}
        errorMessage={errorMessage}
        success={success}
        onSubmit={(formValues) => this.onHandleSubmit(formValues)}
      />
    );
  }
}

export default StandardDeviceWaitKeyView;
